module.exports = __webpack_public_path__ + "img/spin-btn.b68c5c12.png";